<template> 
<div>
  <ProductPage :slug="slug"/>
</div>
</template>

<script>
  import { defineComponent, useRoute } from "@nuxtjs/composition-api";
  import ProductPage from '~/pages/Product/index.vue'
  export default defineComponent({
    components : {
      ProductPage
    },
    setup() {
      const route = useRoute();
      const slug = route.value.params.slug;

      
      return {
        slug
      };
    },
  });
</script>
